import { db } from ".";
import { WaybillNoDocumentNumberResult } from "./tables";

export async function getWaybillNoDocumentNumberResult(waybillNo: string) {
    try {
        const result = await db.waybillNoDocumentNumberResults.where("waybillNo").equals(waybillNo).first();

        if (result && result.created + 48 * 3600 * 1000 > Date.now()) {
            return result;
        }

        return null;
    } catch (error) {
        return null;
    }
}

/**
 * 批量查询打印序号
 */
export async function batchGetWaybillNoDocumentNumberResults(waybillNos: string[]) {
    try {
        const execResults = await db.waybillNoDocumentNumberResults.where("waybillNo").anyOf(waybillNos).toArray();

        const results = execResults.filter((result) => {
            if (result && result.created + 48 * 3600 * 1000 > Date.now()) {
                return true;
            }

            return false;
        });

        return results;
    } catch (error) {
        return [];
    }
}

export async function batchUpdateOrderPrintableDocumentNumber(list: WaybillNoDocumentNumberResult[]) {
    for (let i = 0; i < list.length; i++) {
        const data = list[i];

        try {
            await updateOrderPrintableDocumentNumber(data);
        } catch (error) {
            //TODO: 回传日志
            console.error("保存打印序号失败", error, data);
        }
    }
}

export async function updateOrderPrintableDocumentNumber(data: WaybillNoDocumentNumberResult) {
    const result = await db.waybillNoDocumentNumberResults.where("waybillNo").equals(data.waybillNo).first();

    if (result) {
        await db.waybillNoDocumentNumberResults.update(result.id, data);
    } else {
        await db.waybillNoDocumentNumberResults.add(data);
    }
}
